<template lang="pug">
.wrapper
    .main-container
        HeaderGlobal(HeaderGlobalHeading="ACL" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            .box__header.no-border
                header.flex.items-center.justify-between
                    .header-meta
                        h2.subheading {{ page_title }}
                    .header-cta
                        button.btn-default.mr-4(type='button' @click="reset()")
                            Strong Reset
                        button.btn-primary(type='submit' @click="submit")
                            Strong Save
            .box__body.p-4
                form#form-acl
                    .table-static.w-full.table-acl
                        table
                            thead(v-if="tableThead.length > 0")
                                tr
                                    //- th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')") {{ th.name }}
                                    th(v-for="(th,index) in tableThead" :key="index" :class="(th.number && th.number===true ? 'number' : '')+(th.action && th.action===true ? ' thead-action' : '')")
                                        .wrapper-checkbox(v-if="th.name !== null && th.name !== ''")
                                            input(type="checkbox" @change="roleCheckAll($event,th.id)" :value="th.id" v-model="checkedAllRoles")
                                            .ui-checkbox.flex.items-center
                                                .checkbox.flex.items-center.justify-center
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                strong Check All
                                                //- strong All
                            tbody
                                tr(v-if="load_data_status_acl_list === 'loading'")
                                    //- td.text-center(:colspan="tableThead.length")
                                    td.text-center
                                        .flex.flex-wrap.items-center.justify-center
                                            Spinner(show="true" size="48")
                                        
                                template(v-else-if="acl_list.module && acl_list.module.length > 0")
                                    //- tr(v-for="(mod,index) in acl_list.module" :key="mod.id")
                                        td {{ mod.name }}

                                    template(v-for="(mod,index) in acl_list.module")
                                        tr.roles
                                            th
                                            //- th {{ acl_list.role[0].name }}
                                            th(v-for="role in acl_list.role" :key="role.id")
                                                | {{ role.name }}
                                        tr.modules
                                            th {{ mod.name }}
                                            template(v-if="acl_list.role && acl_list.role.length > 0")
                                                th.text-center(v-for="role in acl_list.role" :key="role.id")
                                                    .wrapper-checkbox
                                                        input(type="checkbox" @change="parentCheck($event,mod.id,role.id)" :value="mod.id+'_'+role.id" v-model="parentChecked")
                                                        .ui-checkbox.flex.items-center
                                                            .checkbox.flex.items-center.justify-center
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                            //- strong mod.id: {{ mod.id }}, role.id :{{ role.id }}
                                                            //- strong mod.id: {{ mod.id }}, role.id :{{ Object.values(role.function) }}
                                                            //- strong mod.id: {{ mod.id }}, role.id :{{ role.function.filter(function(item) { return item.module_id == mod.id; }) }}

                                        template(v-if="mod.function.length > 0")
                                            tr(v-for="(func,index) in mod.function" :key="func.id")
                                                td {{ func.name }}
                                                template(v-if="acl_list.role && acl_list.role.length > 0")
                                                    td.text-center(v-for="role in acl_list.role" :key="role.id")
                                                        .wrapper-checkbox
                                                            //- input(v-if="role.function.filter(function(item) { return item.module_id == mod.id && item.id == func.id; }).length > 0" type="checkbox" checked="checked" :class="'module-'+ mod.id +'-role-'+ role.id" :value="mod.id+'_'+role.id+'_'+func.id" :name="'check['+ mod.id +']['+ role.id +']['+ func.id +']'" v-model="checkedData")
                                                            //- input(v-else type="checkbox" :class="'module-'+ mod.id +'-role-'+ role.id" :value="mod.id+'_'+role.id+'_'+func.id" :name="'check['+ mod.id +']['+ role.id +']['+ func.id +']'" v-model="checkedData")
                                                            input(type="checkbox" :class="'module-'+ mod.id +'-role-'+ role.id" :value="mod.id+'_'+role.id+'_'+func.id" v-model="checkedData")
                                                            .ui-checkbox.flex.items-center
                                                                .checkbox.flex.items-center.justify-center
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                                //- strong mod.id: {{ mod.id }}, func.id :{{ func.id }}, role.id :{{ role.id }}
                                                                //- strong mod.id: {{ mod.id }}, role.id :{{ role.function.filter(function(item) { return item.module_id == mod.id && item.id == func.id; }).length }}

                                tr(v-else)
                                    //- td.text-center(:colspan="tableThead.length") No Data Available
                                    td.text-center No Data Available

                    .flex.items-center.justify-end.mt-4
                        button.btn-default.mr-4(type='button' @click="reset()")
                            Strong Reset
                        button.btn-primary.mr-4(type='submit' @click="submit")
                            Strong Save


</template>

<script>
import { mapState } from 'vuex';
import HeaderGlobal from '@/components/HeaderGlobal.vue';
import Spinner from '@/components/Spinner.vue';

export default {
    name: 'PageAcl',
    components: {
        HeaderGlobal,
        Spinner,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'ACL',
                    url: '/acl',
                }
            ],
            page_title: 'ACL List',

            checkedAllRoles: [],
            parentChecked: [],
            checkedData: [],
            tableThead: [],
            // tableThead: [
            //     {
            //         name: '',
            //         // number: true,
            //     }
            //     // ,{
            //     //     name: 'Label',
            //     // },{
            //     //     name: 'Key',
            //     // },{
            //     //     name: 'Secret',
            //     // },{
            //     //     name: 'Status',
            //     // },{
            //     //     name: 'Description',
            //     // },{
            //     //     name: 'Action',
            //     //     action: true,
            //     // },
            // ],
        };
    },
    computed: {
        ...mapState([
            'load_data_status_acl_list',
            'acl_list',
        ]),
        route_name() {
            return this.$route.name;
        },
    },
    watch: {
        route_name() {
            this.getData();
        },
        // load_data_status_acl_list() {},
        load_data_status_acl_list(newData) {
            if (newData === 'loading') {
                // this.showLoading(true);
            } else if (newData === 'empty') {
                this.error('Data is empty.');
            } else if (newData === 'failed') {
                this.error('Failed to get acl data.');
            } else {
                // this.showLoading(false);
            }
        },
        acl_list(newData) {
            if (Object.keys(newData).length > 0) {

                // table thead
                let tHead = [
                    {
                        name: '',
                        // number: true,
                    }
                ];

                if (newData.role && newData.role.length > 0) {
                    for (var z = 0; z < newData.role.length; z++) {
                        tHead.push(newData.role[z]);
                    }
                }
                this.tableThead = tHead;

                // check checked value
                var modules = newData.module;
                var roles = newData.role;
                let checked = [];
                
                if (modules.length > 0) {
                    for (var i = 0; i < modules.length; i++) {
                        var functions = modules[i].function;
                        
                        if (functions.length > 0) {
                            for (var j = 0; j < functions.length; j++) {
                                // functions[j]

                                if (roles.length > 0) {
                                    for (var k = 0; k < roles.length; k++) {
                                        // roles[k]

                                        if (roles[k].function.filter(function(item) { 
                                            return item.module_id == modules[i].id && item.id == functions[j].id; 
                                        }).length > 0)
                                        checked.push(modules[i].id +'_'+ roles[k].id +'_'+ functions[j].id);
                                    }
                                }
                            }
                        }
                    }
                }

                this.checkedData = checked;
            } else {
                this.tableThead = [];
            }
        },
        tableThead() {},
    },
    methods: {
        roleCheckAll(e,role_id) {
            // if (e.target.checked) {
            //     console.log('on roleCheckAll() checked, ' + role_id);
            // } else {
            //     console.log('on roleCheckAll() unchecked, ' + role_id);
            // }

            // ------------------------------------------------------------------

            if (Object.keys(this.acl_list).length > 0) {
                var modules = this.acl_list.module;
                var roles = this.acl_list.role;
                let parentChecked = this.parentChecked;
                let checkedData = this.checkedData;
                let splitParentChecked;
                let splitCheckedData;
                let index;

                if (modules.length > 0) {
                    for (var i = 0; i < modules.length; i++) {
                        var functions = modules[i].function;
                        
                        if (functions.length > 0) {
                            for (var j = 0; j < functions.length; j++) {
                                // functions[j]

                                if (roles.length > 0) {
                                    for (var k = 0; k < roles.length; k++) {
                                        // roles[k]

                                        if (e.target.checked) {

                                            if (roles[k].id == role_id && parentChecked.filter(function(item) { 
                                                splitParentChecked = item.split("_");
                                                return splitParentChecked[1] == role_id;
                                            }).length > 0) {
                                                // remove array
                                                index = parentChecked.indexOf(modules[i].id +'_'+ roles[k].id);
                                                if (index > -1)
                                                  parentChecked.splice(index, 1);
                                            }

                                            if (roles[k].id == role_id && checkedData.filter(function(item) { 
                                                splitCheckedData = item.split("_");
                                                return splitCheckedData[1] == role_id;
                                            }).length > 0) {
                                                // remove array
                                                index = checkedData.indexOf(modules[i].id +'_'+ roles[k].id +'_'+ functions[j].id);
                                                if (index > -1)
                                                  checkedData.splice(index, 1);
                                            }

                                            if (roles[k].id == role_id) {
                                                parentChecked.push(modules[i].id +'_'+ roles[k].id);
                                                checkedData.push(modules[i].id +'_'+ roles[k].id +'_'+ functions[j].id);
                                            }

                                        } else {

                                            if (roles[k].id == role_id) {
                                                index = parentChecked.indexOf(modules[i].id +'_'+ roles[k].id);
                                                if (index > -1)
                                                  parentChecked.splice(index, 1);

                                                index = checkedData.indexOf(modules[i].id +'_'+ roles[k].id +'_'+ functions[j].id);
                                                if (index > -1)
                                                  checkedData.splice(index, 1);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                this.parentChecked = parentChecked;
                this.checkedData = checkedData;
                // console.log(checkedData)
            }
        },
        parentCheck(e,module_id,role_id) {

            // console.log([module_id,role_id]);
            // let checkboxes = document.querySelectorAll('.module-'+ module_id +'-role-'+ role_id);

            // // console.log(checkboxes);
            // // console.log(checkboxes.length);

            // let i=0;

            // if (e.target.checked) {
            //     // console.log('on parentCheck() checked');

            //     for (i=0; i < checkboxes.length; i++) {
            //         checkboxes[i].setAttribute("checked", "checked");
            //     }
            // } else {
            //     // console.log('on parentCheck() unchecked');

            //     for (i=0; i < checkboxes.length; i++) {
            //         checkboxes[i].removeAttribute("checked");
            //     }
            // }

            // ----------------------------------------------------------------

            if (Object.keys(this.acl_list).length > 0) {
                var modules = this.acl_list.module;
                var roles = this.acl_list.role;
                let checkedData = this.checkedData;
                let splitCheckedData;
                let index;

                if (modules.length > 0) {
                    for (var i = 0; i < modules.length; i++) {
                        var functions = modules[i].function;
                        
                        if (functions.length > 0) {
                            for (var j = 0; j < functions.length; j++) {
                                // functions[j]

                                if (roles.length > 0) {
                                    for (var k = 0; k < roles.length; k++) {
                                        // roles[k]

                                        if (e.target.checked) {

                                            if (modules[i].id == module_id && roles[k].id == role_id && checkedData.filter(function(item) { 
                                                splitCheckedData = item.split("_");

                                                return splitCheckedData[0] == module_id && splitCheckedData[1] == role_id && splitCheckedData[2] == functions[j].id;
                                            }).length > 0) {
                                                // console.log(modules[i].id +'_'+ roles[k].id +'_'+ functions[j].id);

                                                // remove array
                                                index = checkedData.indexOf(modules[i].id +'_'+ roles[k].id +'_'+ functions[j].id);
                                                if (index > -1)
                                                  checkedData.splice(index, 1);
                                            }

                                            if (modules[i].id == module_id && roles[k].id == role_id)
                                                // console.log('on parentCheck() checked');
                                                checkedData.push(modules[i].id +'_'+ roles[k].id +'_'+ functions[j].id);

                                        } else {

                                            if (modules[i].id == module_id && roles[k].id == role_id) {
                                                // console.log('on parentCheck() unchecked');

                                                index = checkedData.indexOf(modules[i].id +'_'+ roles[k].id +'_'+ functions[j].id);
                                                if (index > -1)
                                                  checkedData.splice(index, 1);
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                this.checkedData = checkedData;
            }
        },
        getData() {
            // console.log('=================== getData() route on acl form')

            if (this.route_name === 'PageAcl') {
                
                this.checkedAllRoles = [];
                this.parentChecked = [];
                this.$store.commit('setAclList', {});

                // for dispatch get data
                this.$store.dispatch('getAclList');
            }
        },
        reset() {
            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset form?',
                // text: id,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                if (result.isConfirmed) {
                    this.getData();
                }
            });
        },
        submit(e){
            e.preventDefault();
            // console.log(this.checkedData);

            this.showLoading(true);

            let roles = (this.acl_list.role ? this.acl_list.role : []);

            if (roles.length > 0) {
                let data = [];
                let checkedData = this.checkedData;
                let splitCheckedData;
                let find;
                let current_role_index;

                data = roles.map(function(item) {
                    return {
                        role_id: item.id,
                        function: [],
                    };
                });

                if (checkedData.length > 0) {
                    for (var i = 0; i < checkedData.length; i++) {

                        splitCheckedData = checkedData[i].split("_");

                        if (data.length > 0) {
                            find = false;
                            current_role_index = null;
                            for (var j = 0; j < data.length; j++) {
                                if (data[j].role_id === parseInt(splitCheckedData[1])){
                                    find = true;
                                    current_role_index = j;
                                }
                            }

                            if (find)
                                data[current_role_index].function.push(parseInt(splitCheckedData[2]));
                        }
                    }
                }

                this.$store.dispatch('getAclUpdate', [JSON.stringify(data)])
                .then((resp) => {
                    if (resp.result === 'success') {
                        this.getData();

                        this.$swal.fire({
                            icon: 'success',
                            title: 'Data successfully updated!',
                            timer: 3000,
                        });
                    } else {
                        if (resp.data.message && resp.data.message.errors) {
                            this.error(null, resp.data.message.errors);
                        } else {
                            this.error(resp.data.message ? resp.data.message : null);
                        }
                    }
                });
            } else {
                this.error('No available data to save.');
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        error(message=null, data=null) {
            let errors = '';

            if (data !== null) {
                Object.keys(data).forEach(function (item) {
                    errors += data[item] + '<br><br>';
                    // errors += '<div class="swal2-html-container" style="display: block;">' + data[item] + '<div>';
                });
            }

            this.$swal.fire({
                icon: 'error',
                title: 'Failed!',
                text: (message? message : 'Something wrong.'),
                html: errors,
                // timer: 3000
            });
        },
    },
    mounted() {
        // console.log('=================== mounted on acl form')
        this.getData();
    },
}
</script>

<style lang="sass">

.table-acl
    overflow-x: scroll

.table-static.table-acl
    table
        width: 100%
        thead
            tr
                th
                    font-size: 13px
                    text-align: center
                    padding: 0.5rem
                    white-space: nowrap
        tbody
            tr
                th
                    text-align: left
                    padding: 0.5rem
                td
                    padding: 0.5rem
                    &:first-child
                        padding-left: 1.5rem
            tr.roles
                th
                    text-align: center
                    white-space: nowrap
            tr.modules
                th
                th.text-center
                    text-align: center

</style>
